import { PAGENAME } from '@/common/common.contants';
import { DefaultLocale } from '@/types/locale.types';

const buildUrl = (
  base: string,
  params: Record<string, string | boolean | number | undefined>
): string => {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== false && value !== '') {
      searchParams.set(key, String(value));
    }
  }
  const qs = searchParams.toString();
  return qs ? `${base}?${qs}` : base;
};
const plpPagePath = (lang: string) => `/${lang}/${PAGENAME.PLP_PAGE}`;
const searchStartPath = (lang: string) => `/${lang}/${PAGENAME.SEARCH_START}`;

export const buildPlpPagePath = ({
  isNative,
  query,
  isMultiSearchList,
  recommendation,
  params,
  lang,
  pid,
}: {
  isNative: boolean;
  query?: string;
  isMultiSearchList?: string | boolean;
  recommendation?: string;
  params?: Record<string, string | undefined>;
  lang?: string;
  pid?: string | null;
}): string =>
  buildUrl(plpPagePath(lang ?? DefaultLocale), {
    ...params,
    q: query || undefined,
    r: recommendation || undefined,
    isMultiSearchList: isMultiSearchList || undefined,
    isNative: isNative || undefined,
    pid: pid ?? undefined,
  });

export const buildSearchPagePath = ({
  isNative,
  query,
  fromPlp,
  params,
  lang,
}: {
  isNative: boolean;
  query?: string;
  fromPlp?: boolean;
  params?: Record<string, string | undefined>;
  lang?: string;
}): string =>
  buildUrl(searchStartPath(lang ?? DefaultLocale), {
    ...params,
    q: query || undefined,
    fromPlp: fromPlp || undefined,
    isNative: isNative || undefined,
  });

export const updateCallbackUrl = () => {
  if (typeof window === 'undefined') return '';

  const currentUrl = window.location.href;

  return currentUrl;
};
